import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import "rxjs/add/operator/takeUntil";
import { Subject } from "rxjs/Subject";

import { ROUTE, LOGO } from "../../shared/constants";
import { AccountLoopBackApiService } from '../../services/api/loopback/custom/account.service';
import { BaseLoopBackStorageService } from '../../services/storage/loopback/base.service';
import { BaseErrorService } from '../../services/error/base.service';
import { APIComponent } from '../../shared/api.component';

declare const swal: any;

@Component({
  selector: 'drx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends APIComponent {
  public loginForm: FormGroup;
  public data: any;
  public logo: string = LOGO;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected formBuilder: FormBuilder,
    protected accountService: AccountLoopBackApiService,
    protected storageService: BaseLoopBackStorageService
  ) {
    super(route, router, formBuilder, storageService, accountService);

    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: ['', Validators.required],
    });
  }

  public ngOnInit() {
    if (this.accountService.isAdmin()) {
      return this.router.navigate([ROUTE.ADMIN]);
    }
  }

  public signIn() {
    this.accountService.login(this.loginForm.value, 'user')
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        if (res['data']) {
          this.storageService.startSession(res['data']);
          if (this.accountService.isAdmin()) {
            return this.router.navigate([ROUTE.ADMIN]);
          }
          return this.router.navigate([ROUTE.USER]);
        } else {
          swal(BaseErrorService.errorMessage('Username or Password is invalid'));
        }
      }, error => {
        swal(BaseErrorService.errorMessage('Username or Password is invalid'));
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts